import { Amplify } from "aws-amplify";
import axios from "axios";

const config = {
  Auth: {
    Cognito: {
      region: process.env.NEXT_PUBLIC_AWS_REGION || "ap-south-1",
      userPoolId:
        process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID || "ap-south-1_cfKLtZkay",
      userPoolClientId:
        process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID ||
        "36sb33rv14hh4usp33ek0vcj9m",
      signUpVerificationMethod: "token",
      authenticationFlowType: "USER_SRP_AUTH",
      loginWith: {
        email: true,
        phone: false,
        username: false,
        oauth: {
          domain:
            process.env.NEXT_PUBLIC_COGNITO_DOMAIN || "dev.paraacrypto.com",
          scopes: ["email", "profile", "openid", "phone"],
          responseType: "token",
          redirectSignIn: [
            // "https://dev.paraacrypto.com/spot-trade",
            // "https://dev.paraacrypto.com",
            "https://dev-infra.paraacrypto.com/spot-trade",
            "https://www.dev-infra.paraacrypto.com/spot-trade",
            "https://dev-infra.paraacrypto.com",
            "https://www.dev-infra.paraacrypto.com",
            "https://ap-south-1cfkltzkay.auth.ap-south-1.amazoncognito.com",
            "https://ap-south-1cfkltzkay.auth.ap-south-1.amazoncognito.com/oauth2/idpresponse",
          ],
          redirectSignOut: [
            // "https://dev.paraacrypto.com",
            // "https://dev.paraacrypto.com/oauth2/idpresponse",
            // "https://dev.paraacrypto.com/spot-trade",
            "https://dev-infra.paraacrypto.com/spot-trade",
            "https://www.dev-infra.paraacrypto.com/spot-trade",
            "https://www.dev-infra.paraacrypto.com",
            "https://dev-infra.paraacrypto.com",
            "https://dev-infra.paraacrypto.com/oauth2/idpresponse",
            "https://www.dev-infra.paraacrypto.com/oauth2/idpresponse",
            "https://ap-south-1cfkltzkay.auth.ap-south-1.amazoncognito.com",
            "https://ap-south-1cfkltzkay.auth.ap-south-1.amazoncognito.com/oauth2/idpresponse",
          ],
          providers: ["Google"],
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
};

// Initialize Amplify only on the client side
if (typeof window !== "undefined") {
  try {
    Amplify.configure(config);
  } catch (error) {
    console.error("Error configuring Amplify:", error);
  }
}
export default config;
